export default function () {
	var hintsExpressions = [];
	var hintsOnPage = angular.element(document.querySelectorAll('[hint-message]'));
	for (var i = 0; i < hintsOnPage.length; i++) {
		hintsExpressions.push(hintsOnPage[i].getAttribute('hint-additional-logic'));
	}
	return hintsExpressions;
};
